import styled, { css } from 'styled-components/macro';
import { mobile } from '../../../utils/css/media';
import { colorWhite } from '../../../utils/css/colors';

export const SalonSearchMapContainer = styled.div<{ height: string }>`
  height: ${({ height }) => height};

  ${mobile(css`
    height: fit-content;
  `)};
`;

export const PageBody = styled.div<{ height: number; isOpen: boolean }>`
  position: relative;
  transform: ${(props) =>
    props.isOpen ? 'translateY(0px)' : `translateY(-${props.height}px)}`};
  transition: transform 0.5s ease-in;
  @media (max-width: 1450px)  {
    overflow-y: hidden;
    padding-top: 80px;
	}
  
  ${mobile(css`
    flex-direction: column;
  `)};
`;

export const ToProfileLinkContainer = styled.div<{ direction?: 'ltr' | 'rtl' }>`
  display: flex;
  flex-direction: ${(props) =>
    props.direction === 'rtl' ? 'row' : 'row-reverse'};
  align-items: center;
  justify-content: space-around;
  position: absolute;
  top: 19px;
  right: ${(props) => (props.direction === 'rtl' ? '2%' : '90%')};
  height: 27px;
  width: 130px;
  background-color: ${colorWhite};
  border-radius: 6px;
  z-index: 10;
  padding: 0.4rem;
  cursor: pointer;

  ${mobile(css`
    justify-content: space-around;
    height: 28px;
    width: 103px;
    top: 18px;
    right: 18%;
  `)};
`;

export const ToProfileLabel = styled.span`
  font-weight: 500;
  font-size: 12px;
  letter-spacing: 0.5px;
  line-height: 21px;
`;

export const ToProfileIcon = styled.img`
  ${mobile(css`
    margin-left: 1rem;
  `)};
`;

export const TooglPageContainer = styled.div`
  display: none;
  margin-inline-start: 4%;
`;
